/* wholesale.js - SAFE FINAL VERSION */

(function () {
  const urlParams = new URLSearchParams(window.location.search);
  const isWholesale =
    urlParams.get('ws') === 'true' ||
    sessionStorage.getItem('is_ws') === 'true';

  if (!isWholesale) return;

  /* ========== 0. 标记 wholesale body class ========== */
  document.documentElement.classList.add('is-wholesale');
  document.body.classList.add('is-wholesale');

  /* ========== 1. 保存批发状态 ========== */
  sessionStorage.setItem('is_ws', 'true');

  const wholesalePortalUrl =
    '/collections/wholesale-order-page-ws-true?ws=true';

  /* ========== 2. 判断页面类型 ========== */
  const isCollectionPage =
    window.location.pathname.includes('/collections/') &&
    !window.location.pathname.includes('/products/');

  const isProductPage =
    window.location.pathname.includes('/products/');

  /* ========== 3. 自动补全链接（安全版） ========== */
  function appendWsToLinks() {
    document.querySelectorAll('a').forEach(link => {
      if (
        !link.href ||
        !link.href.includes(window.location.host) ||
        link.href.includes('ws=') ||
        link.closest('.product-form') ||
        link.closest('.product-single') ||
        link.closest('.product__info') ||
        link.closest('.ajaxcart') ||
        link.closest('.cart-popup')
      ) {
        return;
      }

      const separator = link.href.includes('?') ? '&' : '?';
      link.href = link.href + separator + 'ws=true';
    });
  }
  appendWsToLinks();

  /* ========== 4. Back 按钮（仅 collection） ========== */
  if (isCollectionPage && !document.querySelector('.back-wholesale-btn')) {
    const container =
      document.querySelector('.category-heading') ||
      document.querySelector('.section-header');

    if (container) {
      const backBtn = document.createElement('a');
      backBtn.href = wholesalePortalUrl;
      backBtn.className = 'back-wholesale-btn';
      backBtn.innerText = 'Back to Wholesale Portal';
      container.insertAdjacentElement('afterend', backBtn);
    }
  }

  /* ========== 5. 悬浮 Wholesale 入口（所有批发页） ========== */
  if (!document.querySelector('.ws-floating-btn')) {
    const btn = document.createElement('a');
    btn.className = 'ws-floating-btn';
    btn.href = wholesalePortalUrl;
    btn.innerHTML = '<span>🛒</span> WHOLESALE ORDER PAGE';
    document.body.appendChild(btn);
  }

  /* ========== 6. 批发最低起订金额控制 ========== */
  const MIN_PRICE = 35000; // $350.00

  function enforceWholesaleLimit() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        /* checkout 按钮 */
        const checkoutBtns = document.querySelectorAll(
          'button[name="checkout"], [name="checkout"], .btn-cart-checkout, .ajaxcart__checkout'
        );

        if (cart.total_price < MIN_PRICE) {
          checkoutBtns.forEach(btn => {
            btn.style.opacity = '0.5';
            btn.style.pointerEvents = 'none';
            btn.style.cursor = 'not-allowed';
            if (!btn.dataset.oldText) btn.dataset.oldText = btn.innerHTML;
            btn.innerHTML = 'MIN. $350 REQUIRED';
          });
        } else {
          checkoutBtns.forEach(btn => {
            btn.style.opacity = '1';
            btn.style.pointerEvents = 'auto';
            btn.style.cursor = 'pointer';
            if (btn.dataset.oldText) btn.innerHTML = btn.dataset.oldText;
          });
        }

        /* 进度条 */
        const progressContainer = document.querySelector('.js-free-shipping');
        const progressText = document.querySelector('.js-free-shipping-text');
        const barInner = document.querySelector('.progress-bar');

        if (!progressContainer || !progressText || !barInner) return;

        const percent = Math.min(
          (cart.total_price / MIN_PRICE) * 100,
          100
        );

        if (cart.total_price < MIN_PRICE) {
          const remaining = ((MIN_PRICE - cart.total_price) / 100).toFixed(2);
          progressText.innerText = `Add $${remaining} more for Wholesale Minimum`;
          barInner.style.width = percent + '%';
          barInner.style.backgroundColor = '#000';
        } else {
          progressText.innerText = '✅ Wholesale Minimum Reached';
          barInner.style.width = '100%';
          barInner.style.backgroundColor = '#28a745';
        }
      })
      .catch(err => console.log('Wholesale cart error:', err));
  }

  enforceWholesaleLimit();

  /* 监听 AJAX cart 变化 */
  const observer = new MutationObserver(enforceWholesaleLimit);
  observer.observe(document.body, { childList: true, subtree: true });

})();
